import React from 'react';
import {changeEarringQuantity} from "../lib/actions";
import {connect} from "react-redux";
import {EARRING} from "../../constants";

class QuantityToggle extends React.Component {
    render() {
        let id = 'radio-' + this.props.quantity.description;

        return (
            <>
                <input
                    checked={this.props.isActive}
                    id={id}
                    type="radio"
                    name="Charm Text layout"
                    value={this.props.quantity.description}
                    onChange={() => this.props.onChange(this.props.quantity)}
                />
                <label htmlFor={id} className="product__swatch">
                    {this.props.quantity.description}
                </label>
            </>
        )
    }
}

class QuantitySelector extends React.Component {
    render() {
        return (
            <>
                <div className="product__swatch-container swatch-letter-container">
                    <QuantityToggle isActive={this.props.selectedQuantity === EARRING.ONE} quantity={EARRING.ONE} onChange={this.props.onChange}/>
                    <QuantityToggle isActive={this.props.selectedQuantity === EARRING.PAIR} quantity={EARRING.PAIR} onChange={this.props.onChange}/>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        selectedQuantity: state.earringQuantity,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChange: (quantity) => {
            dispatch(changeEarringQuantity(quantity));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(QuantitySelector);
